import React, { Component } from 'react';

import Lobby from './Lobby';
import ClientIncomingCall from './ClientIncomingCall';
import CallStatus from './shared/CallStatus';
import Chat from './shared/Chat';
import CallScreen from './shared/CallScreen';
import Unsupported from './Unsupported';

import JitsiController from './JitsiController';

import { defineMessages, FormattedMessage, intlShape } from 'react-intl';

import { getTrackId } from './shared/utils';

import {Cam, Caret} from './shared/Icons'
import DetectRTC from 'detectrtc';

const messages = defineMessages({
  noWebcam: {
    id: "Shared.App.NoWebcam",
    defaultMessage: "Es wurde keine Webcam erkannt"
  },
  webcamBusy: {
    id: "Shared.App.WebcamBusy",
    defaultMessage: "Webcam ist belegt. Versuchen Sie es bitte erneut."
  },
  webcamDenied: {
    id: "Shared.App.WebcamDenied",
    defaultMessage: 'Sie müssen Zugriff auf die Webcam erlauben.'
  },
  webcamUnknownError: {
    id: "Shared.App.WebcamUnknownError",
    defaultMessage: 'Unbekannter Webcamfehler: {error}'
  }
});

class ClientApp extends Component {
  static contextTypes = {
      intl: intlShape.isRequired,
  }
  
  constructor(props) {
    super(props);

    this.callStatusTimeout = null;
    this.socket = this.props.socket;
    this.state = this.getInitialState();
    this.config = this.props.config;
    this.lastError = null;

    let OS;
    if (window.navigator.userAgent.match(/Android/i)) {
        OS = 'android';
    } else if (window.navigator.userAgent.match(/iP(ad|hone|od)/i)) {
        OS = 'ios';
    } else if (window.navigator.userAgent.match(/Mac(intosh| OS X)/i)) {
        OS = 'macos';
    } else if (window.navigator.userAgent.match(/Windows/i)) {
        OS = 'windows';
    }
    this.os = OS;

    if (this.state.featuresComplete) {
      const callSound = new Audio('incoming.mp3');
      callSound.loop = true;
      callSound.load();
      this.callSound = callSound;

      navigator.mediaDevices.ondevicechange = () => {
        console.log("Devices changed");
        this.readDevices();
      }
    }
    else {
      this.socket.emit('identify', {userAgent: window.navigator.userAgent});
      this.socket.emit('help', {
        user: this.props.user,
        appointment: this.props.appointment,
        group: this.props.group
      });
      this.socket.on('info', (helpinfo) => {
        this.setState({helpinfo: helpinfo});
      })
      return false;
    }

    this.socket.on('connect', () => {
      this.setState(this.getInitialState(), () => {
        this.socket.emit('identify', {userAgent: window.navigator.userAgent});
        if (this.props.group) {
          this.socket.emit('enqueue', this.getGroupId());
        }
        else {
          this.socket.emit('enqueue', this.props.user);
        }
        this.readDevices();
      });
    });

    this.socket.on('disconnect', () => {
      if (this.state.user) {
        if (this.state.user.pc) {
          this.state.user.pc.close();
          delete this.state.user.pc;
        }
        if (this.state.user.datapc) {
          this.state.user.datapc.close();
          delete this.state.user.datapc;
        }
        delete this.state.user.datachannel;
        delete this.state.user.stream;

        this.state.user.online = false;
        this.setState({user: this.state.user});
      }

      this.setState(this.getInitialState());
    });

    this.socket.on('users', (users) => {
      const user = users.find(u => u.id == this.props.user);

      if (user && !user.online && this.state.user) {
        if (this.state.user.pc) {
          this.state.user.pc.close();
          delete this.state.user.pc;
        }

        if (this.state.user.datapc) {
          this.state.user.datapc.close();
          delete this.state.user.datapc;
        }
        delete this.state.user.datachannel;

        delete this.state.user.stream;
        delete this.state.client.stream;

        this.stopStreams();
        this.clearCall();

        console.log("User went offline");
      }

      this.setState({
        user: user ? Object.assign({messages: []}, (this.state.user || {}), user) : null
      });
    });

    this.socket.on('pc', (msg) => this.processPcMsg(msg));
    this.socket.on('client', (client) => {
      console.log("client", client);
      this.setState({client: client})
    });
  }

  getGroupId() {
    return "group-" + this.props.user + "-" + this.props.group;
  }

  getInitialState() {
    let featuresComplete = this.isAbleToRun();
    return {
      user: null,
      client: null,
      currentScreen: featuresComplete ? 'lobby' : 'notsupported',
      appointment: this.props.appointment,
      group: this.props.group,
      videoDevices: [],
      audioDevices: [],
      name: localStorage.getItem('name'),
      muteRemote: false,
      muteLocal: false,
      disableCam: false,
      activeCamDevice: 0,
      activeVideoDevice: null,
      callStatus: null,
      groupReady: false,
      windowWidth: 0,
      windowHeight: 0,
      featuresComplete: featuresComplete,
      jitsiController: null
    };
  }

  isAbleToRun() {
    return (
      navigator.mediaDevices &&
      DetectRTC.isWebRTCSupported &&
      DetectRTC.isWebSocketsSupported &&
      Audio &&
      !(document.documentMode || /Edge/.test(navigator.userAgent))
    );
  }

  updateName(name) {
    if (name) {
      this.setState({name: name});
      this.sendMessage(this.state.user, {name: name}, 'id');
      localStorage.setItem('name', name);
    }
  }

  slog(msg) {
    setTimeout(() => {
      this.socket.emit('syslog', msg);
    }, 16);

    var args = Array.prototype.slice.call(arguments);
    args.unshift('Syslog:');
    console.log.apply(console, args);
  }

  elog(msg) {
    if (msg === this.lastError) return;
    var args = Array.prototype.slice.call(arguments);
    setTimeout(() => {
      this.socket.emit('errorlog', JSON.stringify(args));
    }, 16);

    args.unshift('Errorlog:');
    console.log.apply(console, args);
    this.lastError = msg;
  }

  ulog(msg) {
    setTimeout(() => {
      this.socket.emit('actionlog', msg);
    }, 16);

    var args = Array.prototype.slice.call(arguments);
    args.unshift('Actionlog:');
    console.log.apply(console, args);
  }
  
  preventDefault(e) {
    e.preventDefault();
  }

  componentDidUpdate(pP, pS) {
    if (this.state.callStatus != pS.callStatus) {
      if (this.state.featuresComplete) {
        this.slog(`Callstatus: ${this.state.callStatus}`);
      }

      if (this.callStatusTimeout !== null) {
        clearTimeout(this.callStatusTimeout);
      }
      
      if (['stopped', 'denied'].indexOf(this.state.callStatus) !== -1) {
        this.state.callStatusTimeout = setTimeout(() => {
          this.clearCallStatus();
        }, 3000);
      }

      if (this.state.callStatus === null) {
        document.body.removeEventListener('touchmove', this.preventDefault);
      }
      else {
        document.body.addEventListener('touchmove', this.preventDefault, { passive: false });
      }
    }
  }

  componentDidMount() {
    window.addEventListener('resize', () => {
      let width = window.innerWidth, height = window.innerHeight;

      if (width !== this.state.windowWidth || height !== this.state.windowHeight) {
        this.setState({
          windowWidth: window.innerWidth,
          windowHeight: window.innerHeight
        }, () => {
          if (this.state.featuresComplete) {
            this.slog(`Resolution: ${this.state.windowWidth}x${this.state.windowHeight}`);
          }
        });
      }
    });
  }

  readDevices() {
    let video = [];
    let audio = [];

    navigator.mediaDevices.enumerateDevices()
      .then((devices) => {
        console.log(devices);
        devices.forEach(d => {
          if (d.kind === 'videoinput') {
            video.push(d);
          }
          else if (d.kind === 'audioinput') {
            audio.push(d);
          }
        });
        
        this.setState({videoDevices: video, audioDevices: audio});

        this.slog(`Videodevices: ${video.length}, Audiodevices: ${audio.length}`);
      })
      .catch(e => { 
        this.elog(e);
      });
  }

  componentWillUpdate(nP, nS) {
    try {
      if (nS.incomingCall) {
        if (!this.state.incomingCall && this.callSound.paused) {
          this.callSound.currentTime = 0;
        }

        if (this.callSound.paused) {
          const playPromise = this.callSound.play();
          if (playPromise !== undefined) {
            playPromise.catch(error => {
              console.log("ERROR", error);
            });
          }
        }
      }
      else {
        this.callSound.pause();
      }
    } catch (e) {
      console.log(e);
    }
  }

  establishDataChannel(contact) {
    console.log("Establishing Datachannel RTC with", contact.id);

    if (contact.datapc && contact.datapc.iceConnectionState !== 'failed' && contact.datapc.iceConnectionState !== 'closed') {
      console.log("Datachannel exists, skipping", contact.pc);
      return;
    }

    const pc = new RTCPeerConnection({
      iceServers: this.props.iceServers
    });

    contact.datapc = pc;

    this.setState({
      user: contact
    });

    pc.oniceconnectionstatechange = (e) => {
      console.log("Datachannel ICE connection state", pc.iceConnectionState);

      if (pc.iceConnectionState === 'disconnected') {
        delete contact.datapc;
        delete contact.datachannel;
        
        this.setState({
          user: contact
        });
      }
    };

    pc.onsignalingstatechange = (e) => {
      console.log("Datachannel Signaling state", pc.signalingState);

      if (pc.signalingState === 'closed') {
        delete contact.datapc;
        delete contact.datachannel;
      }
    };

    pc.onicecandidate = (evt) => {
      if (evt.candidate) {
        console.log("Datachannel Received local ice candidate", evt.candidate);

        const data = {
          'for': contact.id,
          'candidate': evt.candidate,
          'datachannel': true
        };

        this.sendPcCom(data);
      }
    };

    pc.ondatachannel = (evt) => {
      contact.datachannel = evt.channel;
      console.log("Data channel incoming");

      contact.datachannel.onmessage = (evt) => {
        var data = JSON.parse(atob(evt.data));
        this.processDcMessage(data, contact);
      };

      contact.datachannel.onerror = function (error) {
        console.log("Data Channel Error:", error);
      };

      contact.datachannel.onopen = () => {
        console.log("Channel opened");
        this.updateName(this.state.name);
      };

      contact.datachannel.onclose = function () {
        console.log("Channel closed");
        delete contact.datachannel;
      };

      this.setState({
        user: contact
      });
    }
  }

  establishPeerconnection(contact) {
    console.log("Establishing RTC with", contact.id);

    if (contact.pc && contact.pc.iceConnectionState !== 'failed' && contact.pc.iceConnectionState !== 'closed') {
      console.log("PC", contact.pc);
      return;
    }

    const pc = new RTCPeerConnection({
      iceServers: this.props.iceServers
    });

    contact.pc = pc;

    contact.pc.onsignalingstatechange = (e) => {
      console.log("Signaling state", pc.signalingState);

      if (pc.signalingState === 'closed') {
        delete contact.pc;
      }
    };

    contact.pc.onnegotiationneeded = (evt) => {
      console.log("Negotiation needed", "skipping");
      this.sendMessage(this.state.user, {action: 'negotiate'}, 'call');
    };

    pc.onicecandidate = (evt) => {
      if (evt.candidate) {
        console.log("Received local ice candidate", evt.candidate);

        this.sendPcCom({
          'for': contact.id,
          'candidate': evt.candidate
        });
      }
    };

    // once remote track arrives, show it in the remote video element
    pc.ontrack = (evt) => {
      console.log("Ontrack", evt);

      contact.stream = evt.streams[0];

      this.setState({
        user: contact
      });
    }
  }

  processDcMessage(data, contact) {
    if (data.type === 'chat') {
      const messages = contact.messages.slice();
      data.time = new Date(); // send time to arrival time
      messages.push(data);
      contact.messages = messages;
      this.setState({user: contact});
      this.slog(`Chat message received from ${contact.id}`);
    }
    else if (data.type === 'call') {
      const action = data.action;

      switch (action) {
        case 'optimizevideo':
          this.optimizeVideo(data.constraints);
          break;
        case 'stop':
          if (!this.props.group) {
            this.stopCall(data.hide, true);

            if (!data.hide) {
              this.setState({
                callStatus: 'stopped'
              });
            }
          }
          break;
        case 'recover':
          this.switchCam();
          this.setState({
            callStatus: 'recovering'
          });
          break;
        case 'calling':
          if (this.state.group || this.state.groupReady) {
            this.acceptCall();
          }
          else {
            this.setState({
              incomingCall: contact,
              callState: null
            });
          }
          break;
        case 'callstart':
          this.showCall();
          break;
        case 'abort':
          this.setState({
            incomingCall: null
          });
          break;
        case 'accepted':
          this.setState({
            incomingCall: null,
            callStatus: 'accepted'
          });
        break;
        case 'denied':
          this.stopCall();
          this.setState({
            incomingCall: null,
            callStatus: 'denied'
          });
          break;
        default:
      }
    }
  }

  clearCallStatus() {
    this.setState({
      callStatus: null
    });
  }

  processPcMsg(message) {
    const contact = this.state.user;
    let pc = null;
    
    console.log("[<- PC Com <-]", message);

    console.log("Incoming PC", message, "Data channel is", contact.datachannel ? contact.datachannel.readyState : 'not existing');

    if (message.desc || message.candidate) {
      if (message.datachannel) {
        if (!contact.datapc) {
          this.establishDataChannel(contact);
        }

        pc = contact.datapc;
      }
      else {
        if (!contact.pc) {
          this.establishPeerconnection(contact);
        }

        pc = contact.pc;
      }
    }

    setTimeout(() => {
      if (message.desc) {
        const desc = message.desc;

        if (!pc) {
          return;
        }

        // if we get an offer, we need to reply with an answer
        pc.setRemoteDescription(desc)
        .then(function () {
          console.log("Set remote description", desc);
          return pc.createAnswer();
        })
        .then((answer) => {
          pc.setLocalDescription(answer)
          .then(() => {
            console.log("Set local description", answer);
            this.sendPcCom({
              'for': contact.id,
              'desc': answer,
              'datachannel': message.datachannel
            });
          })
          .catch((e) => console.log(e));
        })
        .catch((e) => console.log(e));
      }
      else if (message.candidate) {
        pc.addIceCandidate(message.candidate).catch((e) => console.log(e));
      }
      else {
        this.processDcMessage(message, contact);
      }
    }, 16);
  }

  showCall() {
    if (this.props.group) {
      const groupId = this.getGroupId();

      if (this.state.jitsiController) this.state.jitsiController.unload();

      const jitsiController = new JitsiController(Object.assign({},
        this.props.jitsiConfig,
        {
          onLocalTrack: (track) => {
            this.state.tracks = this.state.tracks.filter(t => {
              return !(t.getType() === track.getType() && t.isLocal());
            });

            if (track.getType() === 'audio' && this.state.muteLocal) track.mute();
            if (track.getType() === 'video' && this.state.disableCam) track.mute();

            this.state.tracks.push(track);

            this.setState({
              tracks: this.state.tracks
            }, () => {
              setTimeout(() => {
                track.detach();
                track.attach(document.querySelector(`#${getTrackId(track)}`));
              });
            });
          },

          onRemoteTrack: (track) => {
            this.state.tracks = this.state.tracks.filter(t => {
              return !(t.getType() == track.getType() && t.getParticipantId() == track.getParticipantId())
            });

            this.setState({
              tracks: this.state.tracks
            }, () => {
              this.state.tracks.push(track);

              this.setState({
                tracks: this.state.tracks,
              }, () => {
                setTimeout(() => {
                  track.detach();
                  track.attach(document.querySelector(`#${getTrackId(track)}`));
                });
              });
            });
          },
          onRemoveTrack: (track) => {
            this.state.tracks = this.state.tracks.filter(t => {
              return !(track.getType() === t.getType() && track.getId() === t.getId())
            });
            
            this.setState({
              tracks: this.state.tracks,
            });
          },
          onConferenceJoined: () => {},
          onUserLeft: (id, tracks) => {
            console.log("User left");
            if (tracks.length) {
              this.state.tracks = this.state.tracks.filter(t => {
                return tracks[0].getParticipantId() !== t.getParticipantId()
              });
            }

            this.setState({
              tracks: this.state.tracks,
            });
          },
          onConnectionSuccess: () => {
            this.state.room = this.state.jitsiController.joinRoom();

            this.setState({
              room: this.state.room,
            });
          },
          onConnectionFailed: (e) => {console.log("Custom error: "  + e);},
          onDeviceListChanged: () => {},
        }
      ), this.props.group ? groupId : ["direct", this.state.user.id, this.state.client.id].join('-') );

      this.setState({
        tracks: [],
        room: null,
        jitsiController: jitsiController
      });
    }
    else {
      if (!this.state.user.pc) {
        this.establishPeerconnection(this.state.user);
      }
  
      if (!this.state.client.stream) {
        this.initialSetupLocalStream();
      }
    }

    this.setState({currentScreen: 'call'});
  }

  initialSetupLocalStream(video) {
    if (this.state.settingUpLocalStream) {
      console.log("Skipping stream setup");
      return;
    }

    console.log("Initial Stream setup");
    this.setupLocalStream({});
  }

  setupLocalStream(video, _camDevice) {
    this.setState({
      settingUpLocalStream: true
    });

    console.log("Stream setup");

    let devices = this.state.videoDevices;
    let camDevice = _camDevice != null ? _camDevice : this.state.activeCamDevice;

    if (camDevice === null || camDevice >= devices.length) {
      camDevice = 0;
      video = {
        facingMode: 'user'
      };
      this.setState({activeCamDevice: 0})
    }

    video = video || {
      deviceId: {exact: devices[camDevice].deviceId},
      width: 1920,
      height: 1080,
      frameRate: 60,
      facingMode: "user"
    };

    navigator.mediaDevices.getUserMedia({
      audio: true,
      video: video
    })
    .then((stream) => {
      console.log("Got local stream");
      this.slog(`Access to webcam granted`);

      const currentStream = this.state.client.stream;

      this.state.client.stream = stream;
      const videoTracks = stream.getVideoTracks();

      if (videoTracks.length && videoTracks[0].getSettings) {
        this.state.client.currentCam = videoTracks[0].getSettings().deviceId;
      }

      if (this.state.user.pc) {
        stream.getTracks().forEach(track => this.state.user.pc.addTrack(track, stream));
        console.log("Added tracks to pc");
      }

      this.setState({
        client: this.state.client,
        settingUpLocalStream: false,
        activeCamDevice: camDevice
      }, () => {
        if (currentStream) {
          currentStream.getTracks().forEach((s) => {
            currentStream.removeTrack(s);
            s.stop();
          });

          if (this.state.user.pc) {
            console.log("Cleaning up stream");
            this.state.user.pc.removeStream(currentStream);
          }
        }

        this.sendMessage(this.state.user, {action: 'negotiate'}, 'call');
      });
    })
    .catch((e) => {
      console.log(e);

      this.elog(`Setup localstream ${e.name}`);

      if ("constraint" in e) {
        switch (e.constraint) {
          case 'width':
            video.width = video.width / 2;

            if (video.width < 480) {
              delete video.width;
            }
            break;
          case 'height':
            video.height = video.height / 2;

            if (video.height < 270) {
              delete video.height;
            }
            break;
          case 'facingMode':
            delete video.facingMode;
            break;
          case 'frameRate':
            video.frameRate = video.frameRate / 2;
            if (video.frameRate < 15) {
              delete video.frameRate;
            }
            break;
          default:
            delete video.frameRate;
            delete video.facingMode;
            this.setupLocalStream(video, camDevice++);
            return;
            break;
        }

        this.setupLocalStream(video, camDevice);
      }
      else {
        switch (e.name) {
          case 'NotFoundError':
          case 'DevicesNotFoundError':
            alert(this.context.intl.formatMessage(messages.noWebcam));
            break;
          case 'AbortError':
          case 'NotReadableError':
          case 'SourceUnavailableError':
            alert(this.context.intl.formatMessage(messages.webcamBusy));
            break;
          case 'PermissionDeniedError':
          case 'SecurityError':
          case 'NotAllowedError':
            alert(this.context.intl.formatMessage(messages.webcamDenied));
            break;
          default:
            alert(this.context.intl.formatMessage(messages.webcamUnknownError, {error: e.name}));
            break;
        }

        this.stopCall();
      }
    });
  }

  optimizeVideo(constraints) {
    if (this.state.client.currentCam) {
      constraints.video.deviceId = {
        exact: this.state.client.currentCam
      };
    }
    
    console.log("Optimisation requested", constraints);

    const requestMedia = (constraints) => {
      navigator.mediaDevices
      .getUserMedia(constraints)
      .then((stream) => {
        let videoTrack = stream.getVideoTracks()[0];

        if (this.state.user.pc) {
          if (!this.state.user.pc.getSenders) return;

          const sender = this.state.user.pc.getSenders().find(s => s.track.kind === videoTrack.kind);

          if (!sender || !sender.replaceTrack) return;
          sender.replaceTrack(videoTrack);

          const client = this.state.client;
          if (videoTrack.getSettings) {
            const videoSettings = videoTrack.getSettings();
            client.currentCam = videoTrack.getSettings().deviceId;
            console.log("Video settings now", videoSettings);
          }

          client.stream.getVideoTracks().forEach(v => {
            v.stop();
            client.stream.removeTrack(v);
          });
          client.stream.addTrack(videoTrack);

          this.setState({
            client: client
          });
        }
      })
      .catch(function(err) {
        console.error('Could not switch video track:', err);
        if ("constraint" in err && err.constraint && err.constraint in constraints) {
          switch (err.constraint) {
            case 'width':
              constraints.width = constraints.width / 2;
              break;
            case 'height':
              constraints.height = constraints.height / 2;
              break;
            case 'frameRate':
              constraints.frameRate = constraints.frameRate / 2;
              break;
            case 'facingMode':
              delete constraints.facingMode;
              break;
            default:
              return;
          }
          requestMedia(constraints);
        }
      });
    };
    requestMedia(constraints);
  }

  showChat() {
    this.setState({currentScreen: 'chat'});
  }

  startCall() {
    this.sendMessage(this.state.user, {action: 'init'}, 'call');

    if (this.props.group) {
      this.setState({
        groupReady: true
      });
      this.showCall();
    }
    else {
      this.setState({
        callStatus: 'calling',
        currentScreen: 'call'
      });
    }
  }

  abortCall() {
    this.sendMessage(this.state.user, {action: 'abort'}, 'call');
    this.setState({
      callStatus: null,
      currentScreen: 'lobby'
    });
  }

  acceptCall() {
    this.sendMessage(this.state.user, {action: 'accepted'}, 'call');

    if (!this.props.group) {
      this.stopCall(true);
    }

    this.setState({
      incomingCall: null,
      groupReady: true
    });
    
    this.showCall();
  }

  denyCall(contact) {
    this.sendMessage(this.state.user, {action: 'denied'}, 'call');
    this.setState({
      incomingCall: null
    });
  }

  stopStreams() {
    if (this.props.group) {
      if (this.state.jitsiController) this.state.jitsiController.unload();

      this.setState({
        jitsiController: null
      });
      return;
    };

    if (this.state.client && this.state.client.stream) {
      this.state.client.stream.getTracks().forEach((s) => {
        this.state.client.stream.removeTrack(s);
        s.stop()
      });

      if (this.state.user.pc) {
        if (this.state.user.pc.signalingState !== 'closed') {
          this.state.user.pc.removeStream(this.state.client.stream);
        }
        this.state.user.pc.getReceivers().forEach(s => s.track.stop());
      }
    }

    if (this.state.user.stream) {
      this.state.user.stream.getTracks().forEach((s) => {
        this.state.user.stream.removeTrack(s);
        s.stop()
      });

      if (this.state.user.pc) {
        if (this.state.user.pc.signalingState !== 'closed') {
          this.state.user.pc.removeStream(this.state.user.stream);
        }
        this.state.user.pc.getSenders().forEach(s => {
          if (s.track) s.track.stop();
        });
      }
    }

    delete this.state.client.stream;
    delete this.state.user.stream;
  }

  stopCall(hideStop, noSend) {
    this.stopStreams();

    if (!noSend) {
      this.sendMessage(this.state.user, {action: 'stop', hide: hideStop}, 'call');
    }

    this.clearCall();
    this.setState({
      client: this.state.client,
      incomingCall: null
    });
  }

  clearCall() {
    if (this.state.user.pc) {
      this.state.user.pc.close();
      delete this.state.user.pc;
    }

    this.setState({
      calling: null,
      muteRemote: false,
      muteLocal: false,
      user: this.state.user,
      disableCam: false,
      currentScreen: 'lobby',
      incomingCall: null,
      callStatus: null
    });
  }
  
  muteRemote() {
    let toggle = !this.state.muteRemote;

    if (this.state.user.stream) {
      this.state.user.stream.getAudioTracks().forEach(s => s.enabled = !toggle);
    }

    this.setState({muteRemote: toggle})

    this.ulog(`Remote ${toggle ? 'muted' : 'unmuted'}`);
  }
  
  muteLocal() {
    let toggle = !this.state.muteLocal;

    /*
    if (this.state.client.stream) {
      this.state.client.stream.getAudioTracks().forEach(s => s.enabled = !toggle);
    }
    */
    
    this.state.tracks.forEach(t => {
      if (t.isLocal() && t.getType() === 'audio') {
        if (toggle) {
          t.mute();
        }
        else {
          t.unmute();
        }
      }
    });
    
    this.setState({muteLocal: toggle})

    this.ulog(`Local ${toggle ? 'muted' : 'unmuted'}`);
  }
  
  disableCam() {
    let toggle = !this.state.disableCam;

    this.state.tracks.forEach(t => {
      if (t.isLocal() && t.getType() === 'video') {
        if (toggle) {
          t.mute();
        }
        else {
          t.unmute();
          if (this.state.jitsiController) {
            this.state.jitsiController.createLocalTracks();
          }
        }
      }
    })
    /*
    if (this.state.client.stream) {
      this.state.client.stream.getVideoTracks().forEach(s => s.enabled = !toggle);
    }
    */

    this.setState({disableCam: toggle});

    this.ulog(`Cam ${toggle ? 'disabled' : 'enabled'}`);
  }
  
  switchCam() {
    let newCD = this.state.activeCamDevice + 1;

    if (newCD >= this.state.videoDevices.length) {
      newCD = 0;
    }

    this.setupLocalStream(null, newCD);

    this.ulog(`Cam switched`);
  }

  recoverStream(kind) {
    if (kind == 'local') {
      console.log("Not trying to recover local stream");
    }
    else if (kind == 'remote') {
      console.log("Trying to recover remote stream");
      if (this.state.user.pc) {
        this.sendMessage(this.state.user, {'action': 'recover'}, 'call');
        this.setState({
          callStatus: 'recovering'
        });
      }
    }
  }

  startChat() {
    this.showChat();
  }

  sendChatMessage(msg) {
    const user = this.state.user;
    let data = {
      from: this.state.client.id,
      text: msg,
      id: this.state.client.id + "-" + user.id + "-" + parseInt(Math.random() * 100000),
      time: new Date()
    };
    
    const messages = user.messages.slice();
    messages.push(data);
    user.messages = messages;
    
    this.sendMessage(user, data, 'chat');

    this.setState({user: user});

    this.ulog(`Chat message sent to ${this.state.user.id}`);
  }

  sendMessage(contact, data, type) {
    if (type === 'chat' || type === 'id') {
      if (contact.datapc && contact.datachannel && contact.datachannel.readyState === 'open') {
        console.log("Sending chat message via datachannel");
        contact.datachannel.send(btoa(JSON.stringify(Object.assign({}, data, {type: type}))));
      }
      else {
        console.log("Datachannel not open, could not deliver chat message. Channel is:", !!contact.datachannel && contact.datachannel.readyState);
      }
    }
    else {
      // send via server
      data.for = contact.id;
      data.type = type;
      this.sendPcCom(data);
      console.log("Sent msg via server", data);
    }
  }

  sendPcCom(data) {
    this.socket.emit('pc', data);
    console.log('[-> PC Com ->]', data);
  }

  streamsRunning() {
    this.setState({
      callStatus: 'established'
    });

    this.slog(`Streams running`);
  }

  render() {
    const isConnected = this.state.client && this.state.user && this.state.user.online;
    const screen = !this.state.featuresComplete || isConnected ? this.state.currentScreen : 'lobby';
    const hasUnreadMessages = this.state.user && this.state.user.messages ? !!this.state.user.messages.filter(m => !m.read).length : false;
    const showCallStatus = ['stopped', 'recovering', 'calling', 'accepted', 'denied'].indexOf(this.state.callStatus) != -1;

    return (
      <div style={{height: '100%'}} className={'flat ' + (this.state.incomingCall || showCallStatus ? 'hasOverlay' : '')}>
        {(screen === 'notsupported') &&
          <Unsupported
            info={this.state.helpinfo}
            user={this.props.user}
            locale={this.props.locale}
          />}
        {(screen === 'lobby') &&
          <Lobby
            appLink={this.props.appLinks[this.os]}
            locale={this.props.locale}
            user={this.state.user}
            appointment={this.state.appointment}
            group={this.state.group}
            hasUnreadMessages={hasUnreadMessages}
            onCall={() => this.startCall()}
            onChat={() => this.startChat()}
            onNameChanged={(name => this.updateName(name))}
            name={this.state.name}
            groupReady={this.state.groupReady}
          />}
        {(screen === 'chat') &&
          <div style={{display:'flex', flexDirection: 'column', height: '100%'}}>
            <div className="screenheader">
              <div className="icon" onClick={() => this.setState({currentScreen: 'lobby'})}>
                <div>
                  <Caret />
                </div>
              </div>
              <div className="description" style={{padding:'0.2em'}}>
                <span style={{fontSize:'80%', display:'block'}}>
                  <FormattedMessage
                    id='Client.App.ChattingWith'
                    defaultMessage='Sie chatten mit {name}'
                    values={{
                      name: <span className="name" style={{fontWeight:600}}>{this.state.user.name}</span>
                    }} />
                </span>
              </div>
              <div className="icon" onClick={() => this.startCall()}>
                <div>
                  <Cam />
                </div>
              </div>
            </div>
            <div style={{flex: 1, overflow:'hidden'}}>
              <Chat
                remote={this.state.user}
                local={this.state.client}
                messages={this.state.user.messages}
                events={[]}
                onMessage={(msg) => this.sendChatMessage(msg)}
                onMessagesUpdate={(messages) => {
                  this.state.user.messages = messages;

                  this.setState({
                    user: this.state.user
                  });
                }}
              />
            </div>
          </div>}
          {(screen === 'call') &&
            <CallScreen
              room={this.state.room}
              group={this.props.group}
              tracks={this.state.tracks}
              jitsiController={this.state.jitsiController}
              style={{width: this.state.windowWidth + 'px', height: this.state.windowHeight + 'px'}}
              onError={(kind) => this.recoverStream(kind)}
              onStreamsRunning={() => this.streamsRunning()}
              onMuteRemote={() => this.muteRemote()}
              onMuteLocal={() => this.muteLocal()}
              onStopCall={() => {this.setState({groupReady: false}); this.stopCall();}}
              onDisableCam={() => this.disableCam()}
              onSwitchCam={() => this.switchCam()}
              muteRemote={this.state.muteRemote}
              muteLocal={this.state.muteLocal}
              disableCam={this.state.disableCam}
              remote={this.state.user}
              local={this.state.client}
              callStatus={this.state.callStatus}
              audioDevices={this.state.audioDevices}
              videoDevices={this.state.videoDevices}
            />}
          {!this.state.incomingCall && showCallStatus &&
            <CallStatus
              callStatus={this.state.callStatus}
              onResetCallStatus={() => this.clearCallStatus()}
              onStopCall={() => this.stopCall()}
              onAbortCall={() => this.abortCall()}
            />
          }
          {(this.state.incomingCall &&
            <ClientIncomingCall
              messages={this.props.messages}
              caller={this.state.incomingCall}
              onAccept={() => this.acceptCall()}
              onDeny={() => this.denyCall()}
            />
          )}
      </div>
    );
  }
}

export default ClientApp;



// WEBPACK FOOTER //
// ./src/ClientApp.js